import { initialState } from './index'
import { deepClone } from '../../../utils/object'

export default {
  setToken (state, { token }) {
    state.token = token
  },

  setUser (state, { user }) {
    state.user = user
  },

  setIsAuthenticated (state, { isAuthenticated }) {
    state.isAuthenticated = isAuthenticated
  },

  setView (state, { view }) {
    state.view = view
  },

  setAcceptedPolicyVersion (state, { acceptedPolicyVersion }) {
    state.user.acceptedPolicyVersion = acceptedPolicyVersion
  },

  setSubscribeToNewsletter (state, { subscribeToNewsletter }) {
    state.user.subscribeToNewsletter = subscribeToNewsletter
  },

  setRatingsReceived (state, { ratings }) {
    state.ratings.received = ratings
  },

  setRatingsGiven (state, { ratings }) {
    state.ratings.given = ratings
  },

  reset (state) {
    state.ratings.received = []
    state.ratings.given = []
    state = deepClone(initialState)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js